import React, { useCallback, useEffect, useState } from 'react';
import './LifelineOrderDetails.scss';
import {
  PaymentDetail,
  ValetInstructions,
  Address,
  OrderBasicInfo,
} from '../../../widgets/Order';
import { Repeat } from 'sushiweb/Icons';
import { Loader, Modal } from '../../../../UiKit';
import { getCurrentTime } from '../../../../utils/CurrentTime';
import { grey } from 'sushiweb/tokens/color';
import { AgentActions, OrderTabs, TakeAwayOrder } from '../../../widgets';
import {
  User,
  Merchant,
  Valet,
  HelpButton,
  ActionsView,
} from '../../../widgets';
import Comments from '../../../../containers/lifeline/comments';
import OrderTracker from '../../../../containers/lifeline/orderTracker';
import OrderTimeline from '../../../../containers/lifeline/orderTimeline';
import OrderAdditionalInfo from '../../../../containers/lifeline/orderAdditionalInfo';
import {
  TransactionsDetails,
  DominosDetails,
  DelightFeature,
  CallLogs,
} from '../../../popups';
import { useHistory } from 'react-router-dom';
import {
  ORDER_EVENTS,
  sendOrderModalEvents,
  sendReloadOrderEvent,
  sendClubbedOrderEvents,
} from '../../../../helpers/analytics/order.analytics';
import { PreviousIssues } from '../../../popups/PreviousIssuesModal/PreviousIssuesModal';
import { TransactionsDetailsV2 } from '../../../popups/TransactionsDetails/TransactionDetailsV2';
import {
  helpDeskOpenedEvent,
  popUpClosedEvent,
  popUpOpenendEvent,
} from '../../../../analytics/events';
import {
  EventType,
  FeatureName,
  MetricsForJumboEvent,
} from '../../../../analytics/constants';

let timerID = null;

export const LifelineOrderDetails = ({
  order = null,
  activeOrderId = null,
  userId = null,
  cartId = null,
  orderInfo = null,
  searchType = '',
  comments,
  isOrderShimmer,
  mapInfo,
  isWFH,
  issueSubmission,
  isTimelineUpdated,
  setIsTimelineUpdated,
  refundWarning,
  setSearchValue = () => {},
  getOrderBasicInfo = () => {},
  closeHelpBox = () => {},
  setOpenHelpSection = () => {},
  setHelpDSectionOrderId = () => {},
}) => {
  const curentTime = getCurrentTime();
  const [isLoading, setLoading] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [orderId, setOrderId] = useState(activeOrderId);
  const [additionalOrderRelation, setAdditionalOrderRelation] = useState('');
  const [lastUpdatedAt, setLastUpdatedAt] = useState(curentTime);
  const [isTimeOut, setIsTimeOut] = useState(false);
  const [transactionDetails, setTransactiondetails] = useState();
  const idsForJumboEvents = {
    [MetricsForJumboEvent.order_id]: orderId,
    [MetricsForJumboEvent.customer_id]: userId,
    [MetricsForJumboEvent.cart_id]: cartId,
  };
  const history = useHistory();

  const orderStatus = mapInfo && mapInfo.status;
  const orderBasicInfo =
    orderId && orderInfo && orderInfo[orderId] ? orderInfo[orderId] : null;
  const isLogOrder =
    orderBasicInfo &&
    orderBasicInfo.order &&
    orderBasicInfo.order.zomato_fulfilled
      ? true
      : false;

  let customClass = order?.selected_order ? 'borderRed' : '';
  const additionalOrderDetails = order?.order?.additional_order_details;

  const reloadOrder = useCallback(
    (order_id) => {
      sendReloadOrderEvent(order_id, userId);
      setLoading(true);
      timerID = setTimeout(() => {
        getOrderBasicInfo(order_id, userId);
        setLoading(false);
      }, 500);
    },
    [userId, getOrderBasicInfo],
  );

  useEffect(() => {
    if (orderId) {
      getOrderBasicInfo(orderId, userId);
    }
    order?.order?.additional_order_details &&
      setAdditionalOrderRelation(order.order.additional_order_details.relation);
    return () => {
      clearTimeout(timerID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const updateTime = setTimeout(() => {
      setIsTimeOut(true);
    }, 300000);
    return () => {
      clearTimeout(updateTime);
    };
  }, [isTimeOut, lastUpdatedAt]);

  const setQueryParams = useCallback(
    (replaceOrderId) => {
      const path = history.location.pathname;
      history.replace(`${path}?type=${searchType}&value=${replaceOrderId}`);
    },
    [history, searchType],
  );

  const getBasicOrderInfoForGivenId = useCallback(
    (order_id) => {
      sendClubbedOrderEvents(
        ORDER_EVENTS.GET_REPLACE_ORDER_BASIC_INFO,
        orderId,
        userId,
        {
          replace_order_id: String(order_id),
        },
      );
      if (searchType === 'order_id') {
        setSearchValue(order_id);
        setQueryParams(order_id);
      }
      setOrderId(order_id);
      reloadOrder(order_id);
    },
    [orderId, userId, searchType, setSearchValue, reloadOrder, setQueryParams],
  );

  const openDominosPopup = useCallback(
    (url, isReportIssue) => {
      const source = isReportIssue ? 'Report an Issue' : '';
      sendOrderModalEvents(ORDER_EVENTS.DOMINOS_MODAL_OPEN, orderId, userId, {
        source: String(source),
      });
      let details = {
        show: true,
        title: 'Ticket Details',
        size: 'large',
        component: <DominosDetails orderId={orderId} url={url} />,
      };
      setPopupData(details);
    },
    [orderId, userId],
  );

  const getTransactionsDetails = useCallback(
    (isReportIssue) => {
      const source = isReportIssue ? 'Report an Issue' : '';
      sendOrderModalEvents(
        ORDER_EVENTS.TRANSACTION_MODAL_OPEN,
        orderId,
        userId,
        {
          source: String(source),
        },
      );
      let details = {
        show: true,
        title: 'Transaction Details',
        size: 'large',
        showScrollBar: true,
        maxHeight: '60vh',
        titleStyle: {
          fontSize: '17px',
          fontWeight: '800',
          marginLeft: '-0.4rem',
        },
        padding: 0,
        paddingTop: 0,
        containerStyles: { margin: '16px 0 20px 0', padding: '0 20px' },
        component: (
          <TransactionsDetailsV2
            cartId={cartId}
            orderId={orderId}
            customerId={userId}
            transactionDetails={transactionDetails}
          />
        ),
        popUpType: FeatureName.TRANSACTIONS,
      };
      setPopupData(details);
    },
    [orderId, userId, transactionDetails],
  );

  const setTransactionDetails = (transactiondetails, updateRefundRetried) => {
    setTransactiondetails(transactiondetails);
  };

  const getDelightFeatureDetails = useCallback(
    (isReportIssue) => {
      const source = isReportIssue ? 'Report an Issue' : '';
      sendOrderModalEvents(
        ORDER_EVENTS.DELIGHT_FEATURE_MODAL_OPEN,
        orderId,
        userId,
        { source: String(source) },
      );
      let details = {
        show: true,
        title: 'User’s Delight Feature',
        size: 'large',
        component: <DelightFeature userId={userId} />,
      };
      setPopupData(details);
    },
    [orderId, userId],
  );

  const handleOrderTabChange = useCallback(
    (relation) => {
      if (!additionalOrderDetails) return;
      const activeOrderId = `${relation}_order_id`;
      const orderType =
        relation === 'parent' ? 'Main Order' : 'Additional Order';
      sendClubbedOrderEvents(
        ORDER_EVENTS.SELECT_CLUBBER_ORDER_TAB_EVENT,
        orderId,
        userId,
        {
          order_type: String(orderType),
          order_id: String(additionalOrderDetails[activeOrderId]),
        },
      );
      closeHelpBox();
      getBasicOrderInfoForGivenId(additionalOrderDetails[activeOrderId]);
    },
    [
      orderId,
      userId,
      additionalOrderDetails,
      getBasicOrderInfoForGivenId,
      closeHelpBox,
    ],
  );

  const handleReportIssueCardLink = useCallback(
    (card) => {
      const orderBasicInfo = orderInfo?.[orderId] ? orderInfo[orderId] : null;
      const { dominos_ticket_details } = orderBasicInfo?.order;
      if (card?.show_dominos_ticket && dominos_ticket_details?.url) {
        openDominosPopup(dominos_ticket_details.url, true);
      } else if (card?.show_delight_ticket) {
        getDelightFeatureDetails(true);
      } else if (card?.show_order_info?.length) {
        setAdditionalOrderRelation(card.show_order_info);
        handleOrderTabChange(card.show_order_info);
      } else {
        getTransactionsDetails(true);
      }
    },
    [
      orderId,
      orderInfo,
      getTransactionsDetails,
      getDelightFeatureDetails,
      openDominosPopup,
      handleOrderTabChange,
    ],
  );

  const showValetInstruction = orderBasicInfo?.order?.is_live
    ? true
    : orderBasicInfo?.order?.delivery_instruction.length
    ? true
    : false;

  const closeModal = () => {
    popUpClosedEvent({
      event_type: EventType.CLICK,
      feature_name: popupData?.popUpType,
      ...idsForJumboEvents,
    });
    setPopupData(null);
  };

  const RefreshHandler = () => {
    reloadOrder(orderId);
    setIsTimeOut(false);
    setLastUpdatedAt(getCurrentTime());
  };

  const openCallLogsModal = () => {
    popUpOpenendEvent({
      event_type: EventType.CLICK,
      feature_name: FeatureName.CALL_LOGS,
      ...idsForJumboEvents,
    });
    setPopupData({
      show: true,
      title: 'Call History',
      component: <CallLogs orderId={orderId} userId={userId} />,
      size: 'huge',
      popUpType: FeatureName.CALL_LOGS,
      maxHeight: '80vh',
      padding: 0,
      paddingTop: '1rem',
      containerStyles: { margin: '16px 0 0px 0', padding: '0 20px' },
    });
  };

  const openHelpSectionPopUp = useCallback(() => {
    setHelpDSectionOrderId(order?.order?.order_id);
    setOpenHelpSection(true);
    helpDeskOpenedEvent({
      [MetricsForJumboEvent.order_id]: order?.order?.order_id,
    });
  }, [setHelpDSectionOrderId, setOpenHelpSection, order]);

  return (
    <div className={`lifelineDetailContainer col ${customClass}`}>
      {!!additionalOrderDetails && (
        <OrderTabs
          relation={additionalOrderRelation}
          handleTabChange={handleOrderTabChange}
        />
      )}
      {isLoading ? (
        <div className='individualOrderloader'>
          <Loader />
        </div>
      ) : (
        <div className='orderDetailWrapper'>
          <div className='orderDetail'>
            {issueSubmission?.orderId === orderId &&
            issueSubmission?.hasSubmission ? (
              <div className='individualOrderloader'>
                <Loader />
              </div>
            ) : (
              <React.Fragment>
                <div className='top'>
                  <OrderBasicInfo
                    orderId={orderId}
                    userId={userId}
                    order={orderBasicInfo?.order}
                    getReplaceOrderBasicInfo={getBasicOrderInfoForGivenId}
                  />
                  <OrderAdditionalInfo
                    orderBasicInfo={orderBasicInfo}
                    isOrderShimmer={isOrderShimmer}
                    orderId={orderId}
                    userId={userId}
                    cartId={cartId}
                    comments={comments}
                    retry={getOrderBasicInfo}
                    getTransactionsDetails={getTransactionsDetails}
                    setTransactionDetails={setTransactionDetails}
                    openDominosPopup={openDominosPopup}
                  />
                  <div className='callsStatus tw-flex-col tw-justify-start tw-ml-3'>
                    <div
                      className='colorGreen tw-w-full'
                      onClick={openCallLogsModal}
                    >
                      Call Logs
                    </div>
                    <div
                      className='colorGreen tw-w-full'
                      onClick={openHelpSectionPopUp}
                    >
                      Help
                    </div>
                  </div>
                  <div
                    className='reloadOrder'
                    onClick={reloadOrder.bind(this, orderId)}
                  >
                    <Repeat size={18} color={grey.z500} />
                  </div>
                  <AgentActions
                    orderId={orderId}
                    userId={userId}
                    orderBasicInfo={orderBasicInfo}
                  />
                </div>
                <div className='middle'>
                  <div className='leftSection'>
                    <div className='userSection'>
                      <User
                        orderId={orderId}
                        userId={userId}
                        isWFH={isWFH}
                        refundWarning={refundWarning}
                        cartId={cartId}
                      />
                      <PaymentDetail
                        orderId={orderId}
                        userId={userId}
                        order={orderBasicInfo?.order}
                        retry={getOrderBasicInfo}
                        isOrderShimmer={isOrderShimmer}
                      />
                    </div>
                    <div className='merchantSection'>
                      <Merchant
                        orderId={orderId}
                        userId={userId}
                        isWFH={isWFH}
                        cartId={cartId}
                        order={orderBasicInfo?.order}
                      />
                      {/* <CookingInstructions
                        orderId={orderId}
                        userId={userId}
                        content={orderBasicInfo}
                        retry={getOrderBasicInfo}
                        isOrderShimmer={isOrderShimmer}
                      /> */}
                    </div>
                  </div>
                  <div className='rightSection'>
                    <React.Fragment>
                      <div className='valetSection'>
                        <div className='minHeight'>
                          <Valet
                            orderId={orderId}
                            userId={userId}
                            isWFH={isWFH}
                            isShowCalls={isLogOrder}
                            orderBasicInfo={orderBasicInfo}
                          />
                        </div>
                        {showValetInstruction && (
                          <ValetInstructions
                            order={orderBasicInfo}
                            orderId={orderId}
                            userId={userId}
                            retry={getOrderBasicInfo}
                            isOrderShimmer={isOrderShimmer}
                            orderStatus={orderStatus}
                          />
                        )}
                      </div>
                      <div className='mapSection'>
                        <OrderTracker
                          orderBasicInfo={orderBasicInfo}
                          orderId={orderId}
                          userId={userId}
                        />
                        <Address
                          orderId={orderId}
                          userId={userId}
                          order={orderBasicInfo}
                          isLog={true}
                          isOrderShimmer={isOrderShimmer}
                          mapInfo={mapInfo}
                        />
                      </div>
                    </React.Fragment>
                  </div>
                </div>
                <div className='bottom'>
                  <div className='orderTimeline'>
                    {orderBasicInfo?.order?.is_live && (
                      <div
                        className={
                          isTimeOut ? 'redRefreshAlert' : 'grayRefreshAlert'
                        }
                      >
                        <span>
                          {isTimeOut
                            ? `Last updated a while ago - ${lastUpdatedAt}`
                            : `Last updated at ${lastUpdatedAt} `}
                        </span>
                        <div
                          className='pointer'
                          role='button'
                          tabIndex={0}
                          css={`
                            display: flex;
                            gap: 1rem;
                          `}
                          onClick={RefreshHandler}
                        >
                          <span>
                            <Repeat
                              size={18}
                              color={isTimeOut ? 'red' : 'black'}
                            />
                          </span>
                        </div>
                      </div>
                    )}
                    <OrderTimeline orderId={orderId} userId={userId} />
                  </div>
                  <Comments cartId={cartId} orderId={orderId} />
                </div>
              </React.Fragment>
            )}
          </div>
          <div className='reportIssueWrapper'>
            <ActionsView
              orderId={orderId}
              cartId={cartId}
              userId={userId}
              isTimelineUpdated={isTimelineUpdated}
              setIsTimelineUpdated={setIsTimelineUpdated}
              handleCardLink={handleReportIssueCardLink}
            />
          </div>
        </div>
      )}
      <Modal
        height='100%'
        isVisible={popupData?.show}
        type={popupData?.size}
        title={
          popupData?.title ? (
            popupData?.titleStyle ? (
              <div style={popupData.titleStyle}>{popupData.title}</div>
            ) : (
              <>{popupData.title}</>
            )
          ) : null
        }
        maxHeight={popupData?.maxHeight}
        minHeight={popupData?.minHeight}
        handleClose={closeModal}
        component={popupData?.component}
        showScrollBar={popupData?.showScrollBar}
        paddingTop={popupData?.paddingTop}
        padding={popupData?.padding}
        containerStyles={popupData?.containerStyles}
      />
    </div>
  );
};
